module.exports = __webpack_public_path__ + "img/desaparecidos3.d168024a.jpg";